import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/access.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm access public [<package>]
npm access restricted [<package>]
npm access grant <read-only|read-write> <scope:team> [<package>]
npm access revoke <scope:team> [<package>]
npm access 2fa-required [<package>]
npm access 2fa-not-required [<package>]
npm access ls-packages [<user>|<scope>|<scope:team>]
npm access ls-collaborators [<package> [<user>]]
npm access edit [<package>]
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/access.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <h3>{`Description`}</h3>
    <p>{`Used to set access controls on private packages.`}</p>
    <p>{`For all of the subcommands, `}<inlineCode parentName="p">{`npm access`}</inlineCode>{` will perform actions on the packages
in the current working directory if no package name is passed to the
subcommand.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`public / restricted (deprecated):
Set a package to be either publicly accessible or restricted.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`grant / revoke (deprecated):
Add or remove the ability of users and teams to have read-only or read-write
access to a package.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`2fa-required / 2fa-not-required (deprecated):
Configure whether a package requires that anyone publishing it have two-factor
authentication enabled on their account.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`ls-packages (deprecated):
Show all of the packages a user or a team is able to access, along with the
access level, except for read-only public packages (it won't print the whole
registry listing)`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`ls-collaborators (deprecated):
Show all of the access privileges for a package. Will only show permissions
for packages to which you have at least read access. If `}<inlineCode parentName="p">{`<user>`}</inlineCode>{` is passed in,
the list is filtered only to teams `}<em parentName="p">{`that`}</em>{` user happens to belong to.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`edit (not implemented)`}</p>
      </li>
    </ul>
    <h3>{`Details`}</h3>
    <p><inlineCode parentName="p">{`npm access`}</inlineCode>{` always operates directly on the current registry, configurable
from the command line using `}<inlineCode parentName="p">{`--registry=<registry url>`}</inlineCode>{`.`}</p>
    <p>{`Unscoped packages are `}<em parentName="p">{`always public`}</em>{`.`}</p>
    <p>{`Scoped packages `}<em parentName="p">{`default to restricted`}</em>{`, but you can either publish them as
public using `}<inlineCode parentName="p">{`npm publish --access=public`}</inlineCode>{`, or set their access as public using
`}<inlineCode parentName="p">{`npm access public`}</inlineCode>{` after the initial publish.`}</p>
    <p>{`You must have privileges to set the access of a package:`}</p>
    <ul>
      <li parentName="ul">{`You are an owner of an unscoped or scoped package.`}</li>
      <li parentName="ul">{`You are a member of the team that owns a scope.`}</li>
      <li parentName="ul">{`You have been given read-write privileges for a package, either as a member
of a team or directly as an owner.`}</li>
    </ul>
    <p>{`If you have two-factor authentication enabled then you'll be prompted to
provide an otp token, or may use the `}<inlineCode parentName="p">{`--otp=...`}</inlineCode>{` option to specify it on
the command line.`}</p>
    <p>{`If your account is not paid, then attempts to publish scoped packages will
fail with an HTTP 402 status code (logically enough), unless you use
`}<inlineCode parentName="p">{`--access=public`}</inlineCode>{`.`}</p>
    <p>{`Management of teams and team memberships is done with the `}<inlineCode parentName="p">{`npm team`}</inlineCode>{` command.`}</p>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`registry`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: "`}<a parentName="li" {...{
          "href": "https://registry.npmjs.org/%22"
        }}>{`https://registry.npmjs.org/"`}</a></li>
      <li parentName="ul">{`Type: URL`}</li>
    </ul>
    <p>{`The base URL of the npm registry.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`otp`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or String`}</li>
    </ul>
    <p>{`This is a one-time password from a two-factor authenticator. It's needed
when publishing or changing package permissions with `}<inlineCode parentName="p">{`npm access`}</inlineCode>{`.`}</p>
    <p>{`If not set, and a registry response fails with a challenge for a one-time
password, npm will prompt on the command line for one.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://npm.im/libnpmaccess"
        }}><inlineCode parentName="a">{`libnpmaccess`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-team"
        }}>{`npm team`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-publish"
        }}>{`npm publish`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-config"
        }}>{`npm config`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/registry"
        }}>{`npm registry`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      